// extracted by mini-css-extract-plugin
var _1 = "EditFacesMagneticWall-module__animateUploadProgressBarWidth--dArKv";
var _2 = "EditFacesMagneticWall-module__animatedBackground--nIioo";
var _3 = "EditFacesMagneticWall-module__avatarButton--IKIjW";
var _4 = "EditFacesMagneticWall-module__avatarButtonContainer--_B9fP";
var _5 = "20px";
var _6 = "EditFacesMagneticWall-module__container--n9fRX";
var _7 = "EditFacesMagneticWall-module__editFaceContainer--aCt1p";
var _8 = "EditFacesMagneticWall-module__hasHoveredBlot--gdN7R";
var _9 = "EditFacesMagneticWall-module__hasRing--o3Hcs";
var _a = "EditFacesMagneticWall-module__isDiffMode--kkfKA";
var _b = "EditFacesMagneticWall-module__isInBackground--qM2zE";
var _c = "6px";
var _d = "4px";
var _e = "EditFacesMagneticWall-module__tooltipContainer--rItz4";
var _f = "EditFacesMagneticWall-module__tooltipName--bYcHp";
var _10 = "EditFacesMagneticWall-module__tooltipTitle--BjrLV";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarButton", _4 as "avatarButtonContainer", _5 as "avatarSize", _6 as "container", _7 as "editFaceContainer", _8 as "hasHoveredBlot", _9 as "hasRing", _a as "isDiffMode", _b as "isInBackground", _c as "spacing", _d as "spacingDiffMode", _e as "tooltipContainer", _f as "tooltipName", _10 as "tooltipTitle" }
